export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/users/profile/AccountSetting.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/users/Logout.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
]
